<style type="text/css">
.app-header.navbar,
.app-header.navbar .navbar-brand {
  background-color: #20a8d8;
}

.app-header.navbar .navbar-toggler {
  color: #fff;
  border: 1px solid #fff;
  border-radius: 8px;
  margin-left: 80px;
}

.dropdown-toggle::after {
  border-top: 0.3em solid #fff;
}

.nav-dropdown-items {
  width: 200px;
}

li {
  border-bottom: 1px solid #fff;
}

.crnt_hub {
  color: #fff;
  font-weight: 500;
  line-height: 1;
  font-size: 13px;
}

.sidebar-fixed .sidebar,
.sidebar .sidebar-nav,
.sidebar .nav {
  width: 245px;
}

.sidebar-fixed .main,
.sidebar-fixed .app-footer {
  margin-left: 245px;
}
</style>
<template>
<header class="app-header navbar">
  <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">&#9776;</button>
  <b-link class="navbar-brand" to="/Dashboard"> <img style="max-width:175px" src="../../static/img/logo.png" alt="">
  </b-link>
  <button class="navbar-toggler sidebar-toggler d-md-down-none" type="button" @click="sidebarMinimize">&#9776;</button>
  <!--  <b-nav is-nav-bar class="d-md-down-none">
    <b-nav-item class="px-3">Dashboard</b-nav-item>
    <b-nav-item class="px-3">Users</b-nav-item>
    <b-nav-item class="px-3">Settings</b-nav-item>
  </b-nav> -->
  <b-nav is-nav-bar class="ml-auto" style="margin-right:1%">
    <!--   <b-nav-item class="d-md-down-none">
      <i class="icon-bell"></i><span class="badge badge-pill badge-danger">5</span>
    </b-nav-item> -->
    <!-- <b-nav-item class="d-md-down-none">
      <i class="icon-list"></i>
    </b-nav-item> -->
    <!--    <b-nav-item class="d-md-down-none">
      <i class="icon-location-pin"></i>
    </b-nav-item> -->
    <b-nav-item-dropdown right style="border-bottom: none;">
      <template slot="button-content">
        <div style="display:inline-block;position: relative;top: 5px;">
          <div class="d-md-down-none" style="color: #fff;display:inline-block;">Welcome {{username}} , </div>
          <div class="crnt_hub">{{hubName}} <span>{{brookText}}</span></div>
        </div>
        <div style="display:inline-block;position: relative;bottom: 5px;">
          <img src="static/img/avatars/7.jpg" class="img-avatar" alt="admin@bootstrapmaster.com">
        </div>
      </template>
      <!-- <b-dropdown-item @click="editProfile()"><i class="fa fa-user"></i> Profile</b-dropdown-item> -->
      <b-dropdown-item @click="changehub"><i class="fa fa-sign-out"></i>Change Hub</b-dropdown-item>
      <b-dropdown-item @click="changepasswordRoute"><i class="fa fa-lock"></i> Change Password</b-dropdown-item>
      <b-dropdown-item @click="logout"><i class="fa fa-lock"></i> Logout</b-dropdown-item>
    </b-nav-item-dropdown>
  </b-nav>
  <!--  <button class="navbar-toggler aside-menu-toggler d-md-down-none" type="button" @click="asideToggle">&#9776;</button> -->
</header>
</template>
<script>
import CryptoJS from 'crypto-js';
import apiUrl from '../constants'
import axios from 'axios'
import moment from 'moment'

export default {
  name: 'header',
  data() {
    return {
      username: '',
      usertype: '',
      hubid: '',
      hubName: '',
      brookText:'',
      logindata: []
    }
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.uasertype = userdetail[0].utype;
    this.username = userdetail[0].FirstName;
    this.hubid = userdetail[0].HubId;
    this.getHubName(this.hubid)

    var formatedDateEncrypt = window.localStorage.getItem('loginDate')
    var formatedDateDecrypt = CryptoJS.AES.decrypt(formatedDateEncrypt.toString(), 'Key');
    var plaindate = formatedDateDecrypt.toString(CryptoJS.enc.Utf8);
    var loginDate = JSON.parse(plaindate);
    var date = new Date();

    var cuurDate = moment(date).format('DD-MM-YYYY')
    if (loginDate != cuurDate) {
      this.logout();
    }

  },
  methods: {
    sidebarToggle(e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    getHubName(hubid) {
      this.input = {
        hubids: hubid
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.hubName = result.data.ResponseData[0].HubName + " (" + result.data.ResponseData[0].HubID + ") "
            //this.hubName = result.data.ResponseData[0].HubName;
          } else {
            this.hubName = '';
          }
          if(JSON.parse(result.data.ResponseData[0].ConfigSetting.isbrook)){
            this.brookText="Brook";
          }
          else if(JSON.parse(result.data.ResponseData[0].ConfigSetting.isbond)){
            this.brookText="Bond";
          }
        }, error => {
          console.error(error)
        })
    },

    logout(e) {
      if(apiUrl.isKavachLogin){
        localStorage.clear();
        window.location.href = apiUrl.api_url_kavach_auth + '/realms/xpressbees/protocol/openid-connect/logout?client_id=' + apiUrl.kavach_client_id + '&post_logout_redirect_uri=' + window.location.href;
      }else{
        localStorage.removeItem('permissiondata')
        localStorage.removeItem('userdetail')
        localStorage.removeItem('userToken')
        localStorage.removeItem('isLoggedIn')
        localStorage.removeItem('loginDate')
        localStorage.removeItem('stateCodeList')
        this.$alertify.error('Logged Out')
        this.$router.push('/login')
      }
      e.preventDefault()
    },
    changehub() {
      this.$router.push('/changehub')
    },

    editProfile() {
      if (this.usertype == 'Merchant')
        this.$router.push('/merchantProfile')
      else if (this.usertype == 'Client')
        this.$router.push('/companyProfile')
      else
        this.$router.push('/')
    },
    sidebarMinimize(e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle(e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    asideToggle(e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    },
    changepasswordRoute() {
       this.$router.push('/changepassword')
   },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue?2aac8872